module.exports = __webpack_public_path__ + "static/media/green-box.22f4f8c8.svg";